import { jsx, jsxs } from "react/jsx-runtime";
import { Paragraph, Separator, XStack, YStack } from "tamagui";
function SeparatorDemo() {
  return /* @__PURE__ */ jsxs(YStack, { width: "100%", maxWidth: 300, marginHorizontal: 15, children: [
    /* @__PURE__ */ jsx(Paragraph, { fontWeight: "800", children: "Tamagui" }),
    /* @__PURE__ */ jsx(Paragraph, { children: "A cross-platform component library." }),
    /* @__PURE__ */ jsx(Separator, { marginVertical: 15 }),
    /* @__PURE__ */ jsxs(XStack, { height: 20, alignItems: "center", children: [
      /* @__PURE__ */ jsx(Paragraph, { children: "Blog" }),
      /* @__PURE__ */ jsx(Separator, { alignSelf: "stretch", vertical: true, marginHorizontal: 15 }),
      /* @__PURE__ */ jsx(Paragraph, { children: "Docs" }),
      /* @__PURE__ */ jsx(Separator, { alignSelf: "stretch", vertical: true, marginHorizontal: 15 }),
      /* @__PURE__ */ jsx(Paragraph, { children: "Source" })
    ] })
  ] });
}
export {
  SeparatorDemo
};
//# sourceMappingURL=SeparatorDemo.js.map
